// extra-fx — combined module that aggregates all extra FX categories
// and exports descriptors + lib for wiring into fx.js / glitchfx.js / workers.

const codec = require('./extra-fx-codec');
const generative = require('./extra-fx-generative');
const film = require('./extra-fx-film');
const print = require('./extra-fx-print');
const color = require('./extra-fx-color');
const text = require('./extra-fx-text');
const analysis = require('./extra-fx-analysis');

const descriptors = [
    ...codec.descriptors,
    ...generative.descriptors,
    ...film.descriptors,
    ...print.descriptors,
    ...color.descriptors,
    ...text.descriptors,
    ...analysis.descriptors,
];

const lib = {
    ...codec.lib,
    ...generative.lib,
    ...film.lib,
    ...print.lib,
    ...color.lib,
    ...text.lib,
    ...analysis.lib,
};

// List of all effect names (for building fxNameMap in workers)
function getEffectIds() {
    return descriptors.map(d => d.name);
}

module.exports = { descriptors, lib, getEffectIds };
